import { render, staticRenderFns } from "./StockViewReleaseProduct.vue?vue&type=template&id=19277ed2&scoped=true"
import script from "./StockViewReleaseProduct.vue?vue&type=script&lang=js"
export * from "./StockViewReleaseProduct.vue?vue&type=script&lang=js"
import style0 from "./StockViewReleaseProduct.vue?vue&type=style&index=0&id=19277ed2&prod&lang=scss"
import style1 from "./StockViewReleaseProduct.vue?vue&type=style&index=1&id=19277ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19277ed2",
  null
  
)

export default component.exports